var _rect, _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackendService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64px",
    height: "64px",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cloud Computing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cloud_Computing",
    className: "",
    fillOpacity: 1,
    fill: "#3d43ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,36H27v3H9a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V41H28a1,1,0,0,0,1-1V36h2v8a1,1,0,0,0,2,0V36h2v4a1,1,0,0,0,1,1H54v3a1,1,0,0,0,2,0V40a1,1,0,0,0-1-1H37V36H50a9,9,0,0,0,3-17.48A8,8,0,0,0,44.46,11,15,15,0,0,0,15,14a11,11,0,0,0,1,22Zm0-20a1,1,0,0,0,1-1,13,13,0,0,1,25.72-2.67,1,1,0,0,0,1.17.78,6,6,0,0,1,7.11,6,1,1,0,0,0,.74,1.14A7,7,0,0,1,50,34H16a9,9,0,0,1,0-18Z",
    id: "svg_1",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,46H24a1,1,0,0,0-1,1V59a1,1,0,0,0,1,1h5v2H28a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2H35V60h5a1,1,0,0,0,1-1V47A1,1,0,0,0,40,46ZM33,62H31V60h2Zm6-4H25V48H39Z",
    id: "svg_2",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,46H47a1,1,0,0,0-1,1V59a1,1,0,0,0,1,1h5v2H51a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2H58V60h5a1,1,0,0,0,1-1V47A1,1,0,0,0,63,46ZM56,62H54V60h2Zm6-4H48V48H62Z",
    id: "svg_3",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,46H1a1,1,0,0,0-1,1V59a1,1,0,0,0,1,1H6v2H5a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2H12V60h5a1,1,0,0,0,1-1V47A1,1,0,0,0,17,46ZM10,62H8V60h2Zm6-4H2V48H16Z",
    id: "svg_4",
    fill: "#3d43ac"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackendService);
export default __webpack_public_path__ + "static/media/backend-service.95d7b170caae55744b6c9421d240691c.svg";
export { ForwardRef as ReactComponent };